<div class="modal-body">
  <div id="sms-recaptcha-container"></div>
  <div class="centermodal mb-0">
    <p class="centermodal__title">{{ 'webhooks.endpointSecret' | translate }}</p>
    <p class="centermodal__description">{{ 'webhooks.secretCodeOneTimeMessage' | translate }}</p>
  </div>

  <div class="secret">
    <p class="secret__text">{{ secret }}</p>
    <i class="fal fa-clone secret__icon" (click)="copyToClipboard(secret)"></i>
  </div>

  <div class="centermodal mb-0">
    <div class="tokenField">
      <i class="tokenField__alert-icon"></i>
      <p class="tokenField__alert">{{ 'webhooks.secretCodeOneTimeWarning' | translate }}</p>
    </div>
    <div class="centermodal__button-group mt-3">
      <button type="button" class="btn-M btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    </div>
  </div>
</div>
